import { AxiosRequestConfig } from 'axios';

export const addAuthHeader = (
  config: AxiosRequestConfig,
  accessToken: string,
  replace?: boolean,
) => {
  const containsAuthToken = 'Authorization' in config.headers;

  if (replace || !containsAuthToken) {
    config.headers = {
      ...config.headers,
      Authorization: 'Bearer ' + accessToken,
    };
  }

  return config;
};

export const parseFilename = (header: any) => {
  let filename = '';
  if (header) {
    // Match filename="..." or filename=...
    const match = header.match(/filename="?([^"]+)"?/);
    if (match && match[1]) {
      filename = match[1];
    }
  }
  return filename;
};
